import { useState } from 'react';
import constate from 'constate';

const UseApp = () => {
  const [userMobile, setUserMobile] = useState(['']);
  const [userEmail, setUserEmail] = useState('');
  const [userLicensePlate, setUserLicensePlate] = useState('');
  const [isContinued, setIsContinued] = useState(false);

  return {
    userMobile,
    setUserMobile,
    userEmail,
    setUserEmail,
    userLicensePlate,
    setUserLicensePlate,
    isContinued,
    setIsContinued,
  };
};

const [AppProvider, useAppContext] = constate(UseApp);
export { AppProvider, useAppContext };
